module.exports = __webpack_public_path__ + "72ff7187197d9837aaf59ac989550ee7.jpg";